import React from "react";
import DropdownList from 'react-widgets/lib/DropdownList'
import Multiselect from 'react-widgets/lib/Multiselect';
import { Checkbox, Radio } from "react-bootstrap";
import * as stateConstants from '../../constants/orderStates';

export const ReadonlyInput = ({ value, label }) => (
    <div className='form-group'>
        <label className='control-label col-sm-3' style={{ color: 'gray', fontWeight: 'normal' }}>{label}</label>
        <div className='controls col-sm-9'>
            <input value={value} className='form-control'
                style={{ width: '400px', color: "gray" }}
                readOnly />
        </div>
    </div>
);

export const UnstiledReadonlyInput = ({ value, label }) => (
    <div>
        {label && <label style={{ color: 'gray', fontWeight: 'normal' }}>{label}</label>}
        <div>
            <input value={value} className='form-control'
                style={{ color: "gray" }}
                readOnly />
        </div>
    </div>
);

export const WideField = ({ input, label, type, placeholder, meta: { touched, error, warning } }) => (
    <div className='form-group'>
        <label className='control-label col-sm-3'>{label}</label>
        <div className='controls col-sm-9'>
            <input {...input} value={input.checked} placeholder={placeholder} type={type} />
            {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                <span>{warning}</span>))}
        </div>
    </div>
);

export const SimpleField = ({ input, label, disabled, min, max, type, regexFilter, meta: { touched, error, warning } }) => (
    <div className='form-group'>
        <label className='control-label col-sm-3'>{label}</label>
        <div className='controls col-sm-9'>
            <input {...input}
                min={min}
                max={max}
                placeholder={label}
                type={type}
                style={{ width: '400px', resize: 'vertical' }}
                className='form-control'
                disabled={disabled}
                onChange={(e) => {
                    e.target.value = e.target.value && regexFilter ? e.target.value.replace(regexFilter, '') : e.target.value;
                    input.onChange(e);
                }} />
            {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                <span>{warning}</span>))}
        </div>
    </div>
);

export const ColorInput = ({ input, label, disabled, colors, meta: { touched, error, warning } }) => {
    const c = colors.filter(c => /^#([0-9a-fA-F]{3}){1,2}/.test(c));
    return (
    <div className="form-group">
        <label className="control-label col-sm-3">{label}</label>
        <div className='controls col-sm-9'>
            <input {...input}
                type='color'
                style={{ width: '400px', resize: 'vertical' }}
                className='form-control'
                disabled={disabled}
                list={c && c.length > 0 ? 'colors' : undefined}
                onChange={(e) => {
                    input.onChange(e);
                }}/>
                <datalist id='colors'>
                    {c.map((color, index) => (<option value={color} key={index} />))}
                </datalist>
            {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                    <span>{warning}</span>))}
        </div>
    </div>)
};

export const NumberField = ({ input, label, max, min, customOnChange, disabled, meta: { touched, error, warning } }) => (
    <div>
        {label && <label className='control-label'>{label}</label>}
        <input {...input}
            placeholder={label}
            disabled={disabled}
            type={'number'}
            style={{ resize: 'vertical' }}
            className='form-control'
            max={max}
            min={min}
            onChange={(e) => {
                input.onChange(e);
                if (customOnChange) {
                    customOnChange();
                }
            }} />
        {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
            <span>{warning}</span>))}
    </div>
);

export const UnstiledField = ({ input, label, type, disabled, readOnly, min, max, isHorisontal, meta: { touched, error, warning } }) => (
    <div className={isHorisontal ? 'formGroup' : undefined}>
        {label && <label className={isHorisontal ? 'control-label col-sm-3' : 'control-label'}>{label}</label>}
        <div className={isHorisontal ? 'controls col-sm-9' : undefined}>
            <input {...input}
                min={min}
                max={max}
                placeholder={label}
                type={type}
                style={{ resize: 'vertical' }}
                disabled={disabled}
                className='form-control'
                onChange={input.onChange}
                readOnly={readOnly} />
            {touched && (error && <span style={{ color: 'red', marginLeft: '5px' }}>{error}</span>)}
        </div>
    </div>
);

export const DropdownListField = ({ input, disabled, label, data, def, valueField, textField, meta: { touched, error } }) => (
    <div className='form-group'>
        <label className='control-label col-sm-3'>{label}</label>
        <div className='controls col-sm-9'>
            <DropdownList {...input}
                data={data}
                valueField={valueField}
                textField={textField}
                style={{ width: '400px' }}
                onChange={input.onChange}
                disabled={disabled}
                defaultValue={def} />
            {touched && (error && <span style={{ color: 'red', marginLeft: '5px' }}>{error}</span>)}
        </div>
    </div>
);

export const UnstiledDropdownListField = ({ input, onSelect, valueComponent, label, data, valueField, customOnChange, textField, meta: { touched, error }, disabled }) => (
    <div>
        {label && <label className='control-label'>{label}</label>}
        <DropdownList {...input}
            data={data}
            valueField={valueField}
            textField={textField}
            onChange={(e) => {
                input.onChange(e);
                if (customOnChange){
                    customOnChange(e);
                }
            }}
            disabled={disabled}
            valueComponent={valueComponent}
            filter='contains'
            onSelect={onSelect} />
        {touched && (error && <span style={{ color: 'red', marginLeft: '5px' }}>{error}</span>)}
    </div>
);

export const TextAreaField = ({ input, label, type, meta: { touched, error, warning } }) => (
    <div className='form-group'>
        <label className='control-label col-sm-3'>{label}</label>
        <div className='controls col-sm-9'>
            <textarea {...input}
                placeholder={label}
                type={type}
                style={{ width: '400px', height: '100px', resize: 'vertical' }}
                className='form-control' />
            {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                <span>{warning}</span>))}
        </div>
    </div>
);

export const TextAreaFieldReadOnly = ({ input, label, type, meta: { touched, error, warning } }) => (
    <div className='form-group'>
        <label className='control-label col-sm-3' style={{ color: 'gray', fontWeight: 'normal' }}>{label}</label>
        <div className='controls col-sm-9'>
            <textarea {...input}
                placeholder={label}
                type={type}
                style={{ width: '400px', height: '100px', resize: 'vertical', color: "gray" }}
                className='form-control'
                readOnly/>
            {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                <span>{warning}</span>))}
        </div>
    </div>
);

export const UnstyledTextAreaField = ({ input, disabled, label, type, meta: { touched, error, warning } }) => (
    <div>
        {label && <label className='control-label'>{label}</label>}
        <textarea {...input}
            placeholder={label}
            type={type}
            style={{ height: '100px' }}
            className='form-control'
            disabled={disabled} />
        {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
            <span>{warning}</span>))}
    </div>
);

let CustomStateComponent = class extends React.Component {
    constructor(props) {
        super(props);
    }

    render(){
        const colorOfToadInLove = "#3CAA3C";
        return (<span style={this.props.item.Type === stateConstants.RECEIVING_POINT_ORDER_TYPE ? {color: colorOfToadInLove} : undefined}>{this.props.item.Name}</span>)
    };
}

export const MultiSelectField = ({ input, data, valueField, textField, label, meta: { touched, error, warning } }, useCustomStateComponent) => (
    <div className='form-group'>
        <label className='control-label col-sm-3'>{label}</label>
        <div className='controls col-sm-9'>
            <div style={{ width: '400px' }}>
                <Multiselect {...input}
                    onBlur={() => input.onBlur()}
                    value={input.value || []}
                    data={data}
                    valueField={valueField}
                    textField={textField}
                    placeholder={label}
                    itemComponent={useCustomStateComponent ? CustomStateComponent : undefined}
                    tagComponent={useCustomStateComponent ? CustomStateComponent : undefined} />
                {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                    <span>{warning}</span>))}
            </div>
        </div>
    </div>
);

export const UnstiledMultiSelectField = ({ input, data, valueField, textField, label, meta: { touched, error, warning } }) => (
    <div className='form-group'>
        {label && <label className='control-label'>{label}</label>}
            <div>
                <Multiselect {...input}
                    onBlur={() => input.onBlur()}
                    value={input.value || []}
                    data={data}
                    valueField={valueField}
                    textField={textField}
                    placeholder={label} />
                {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                    <span>{warning}</span>))}
            </div>
    </div>
);

export const UnstiledCheckbox = ({input, label, meta: { touched, error, warning } }) => (
    <div className='form-group'>
        <label className='control-label col-sm-3'>{label}</label>
            <div className='controls col-sm-3'>
                <Checkbox {...input}
                    type={'checkbox'}
                    checked={input.value} />
                {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                    <span>{warning}</span>))}
            </div>
    </div>
);

export const RadioField = ({ input, label, value, showError = false, meta: { touched, error, warning }, ...rest }) => (
    <span>
        <Radio inline type="radio" {...input} {...rest} >{label}</Radio>
        {showError && touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
            <span>{warning}</span>))}
    </span>
);


// WEBPACK FOOTER //
// ./src/components/common/Inputs.jsx